import React from "react";
import PropTypes from "prop-types";
import { library } from "@fortawesome/fontawesome-svg-core";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faExpandArrowsAlt,
	faCompressArrowsAlt
} from "@fortawesome/free-solid-svg-icons";
import screenfull from "screenfull";

import logo from "./logo_pomu_barra.png"; // Tell Webpack this JS file uses this image

library.add(faExpandArrowsAlt);
library.add(faCompressArrowsAlt);

class barraInferior extends React.Component {
	constructor(props) {
		super(props);

		this.changeIcon = this.changeIcon.bind(this);

		this.state = {
			fullscreenIcon: "expand-arrows-alt"
		};
	}

	changeIcon() {
		this.setState({
			fullscreenIcon: screenfull.isFullscreen
				? "compress-arrows-alt"
				: "expand-arrows-alt"
		});
	}
	componentDidMount() {
		screenfull.on("change", this.changeIcon);
	}
	componentWillUnmount() {
		screenfull.off("change", this.changeIcon);
	}

	render() {
		return (
			<div className="BarraInferior">
				<a
					href={this.props.canonical}
					target="_blank"
					rel="noopener noreferrer"
				>
					<img src={logo} alt="Pomu" />
				</a>
				<h1>{this.props.title}</h1>
				{screenfull.enabled ? (
					<button onClick={() => screenfull.toggle()}>
						<FontAwesomeIcon
							className="icon"
							icon={this.state.fullscreenIcon}
							size="2x"
						/>
					</button>
				) : (
					<div />
				)}
			</div>
		);
	}
}
barraInferior.propTypes = {
	title: PropTypes.string.isRequired,
	canonical: PropTypes.string.isRequired
};
barraInferior.defaultProps = {};

export default barraInferior;
